//Merge together the meta values so that child route meta values overwrite parent ones
//Lets us simplify how we structure routing and set meta vals
export function getMergedMeta(route) {
    return route.matched.reduce((meta, match) => {
        return { ...meta, ...match.meta }
    }, {})
}
